import { createEducationalAssignmentPdf } from "../helpers/educational-assignment-pdf";

export default {
  methods: {
    async buildAssignmentAnswerPdf(assignmentId, materialId) {
      const reportResponse = await this.$api.getAnswerReport(assignmentId, materialId);
      if (this.$handleResponse && !this.$handleResponse(reportResponse)) return null;
      return createEducationalAssignmentPdf(reportResponse.data.payload, {
        router: this.$router,
        encryptData: (value) => this.$encryptData(value),
        getCaseSlideIds: async (caseId, params) => {
          const response = await this.$api.getSlideIdsByCaseDetailIdFact(caseId, params);
          return response.data.status === true ? response.data.payload : null;
        },
      });
    },

    async createAssignmentAnswerLink(materialId, expirationDays) {
      try {
        const pdfAttachment = await this.buildAssignmentAnswerPdf(undefined, materialId);
        if (!pdfAttachment) return null;
        const response = await this.$api.createAnswerPdfLink(materialId, { ...pdfAttachment, expirationDays });
        if (this.$handleResponse && !this.$handleResponse(response)) return null;
        return response.data.payload;
      } catch (error) {
        this.$handleError(error);
        return null;
      }
    },

    async sendAssignmentAnswer({ assignmentId }) {
      try {
        const pdfAttachment = await this.buildAssignmentAnswerPdf(assignmentId);
        if (!pdfAttachment) return false;
        const response = await this.$api.shareAnswer(assignmentId, pdfAttachment);
        if (this.$handleResponse && !this.$handleResponse(response)) return false;
        this.$toastr("success", "Answer shared successfully!");
        return true;
      } catch (error) {
        this.$handleError(error);
        return false;
      }
    },
  },
};
